import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { sortPropertyListByName } from '../../../../../helpers/Utils';
import {
  gAPI_Property_List_By_Group,
  API_SALESFORCE,

  gAPI_Ingetration,
} from '../../../../../constants/APIs';

import {
  dAPI_Delete_Ingetration,
  API_GooleAnalytics,
} from '../../../../../constants/APIs';
import { Changecloudbeds } from '../../../../../redux/actions';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Validation from '../../../../../components/Validation';
let arr = [];
function GoogleAnalyticsIntegration({ visible, toggle, id, serviceProvider }) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [property, setProperty] = useState([]);
  const [maskData, setMaskData] = useState({
    clientId: '',
    clientSecretKey: '',
  });
  const isAvenProvider = serviceProvider === '2' || serviceProvider === '5';
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: 'Google Analytics',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    utmSource: isAvenProvider ? 'AvenHospitality' : '',
    utmMedium: isAvenProvider ? 'Concierge' : '',
  });
  useEffect(() => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${API_GooleAnalytics}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setInputData(prev => ({
            ...prev,
            Name: res.data.name,
            Properties: res.data.properties ?? [],
            // utmSource: (res.data.googleAnalyticsIntegration.utmSource),
            // utmMedium: (res.data.googleAnalyticsIntegration.utmMedium),
            utmSource: (res.data.googleAnalyticsIntegration?.utmSource) || (isAvenProvider ? 'AvenHospitality' : ''),
            utmMedium: (res.data.googleAnalyticsIntegration?.utmMedium) || (isAvenProvider ? 'Concierge' : ''),
          }));

          setMaskData({
            ...maskData,
            utmSource: (res.data.googleAnalyticsIntegration.utmSource),
            utmMedium: (res.data.googleAnalyticsIntegration.utmMedium),
          });
        });
      // .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id, serviceProvider]);
  const mask = (value) => {
    console.log(value);
    let maskedValue = '';
    for (let i = 0; i < value.length - 2; i++) {
      maskedValue += '*';
    }
    return maskedValue + value.substring(value.length - 2, value.length);
  };

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleClientKeyChange = (e) => {
    e.persist();
    setInputData({ ...inputData, utmSource: e.target.value });
    //console.log(inputData)
  };
  const handleClientSecretChange = (e) => {
    e.persist();
    setInputData({ ...inputData, utmMedium: e.target.value });
    //console.log(inputData)
  };

  const handleCheckChange = (e) => {
    if (inputData.Properties.filter((p) => p.id === e).length > 0) {
      setInputData({ ...inputData, Properties: inputData.Properties.filter((p) => p.id !== e) });
    }
    else {
      let obj = inputData.Properties;
      obj.push(e);
      setInputData({ ...inputData, Properties: obj });
    }
  };

  const sortedProperties = sortPropertyListByName(property);

  const allSelected =
    sortedProperties.length > 0 &&
    sortedProperties.every((p) =>
      inputData.Properties.includes(p.id)
    );
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = sortedProperties.map((p) => p.id);
      setInputData({ ...inputData, Properties: allIds });
    } else {
      setInputData({ ...inputData, Properties: [] });
    }
  };

  const handleSave = async () => {
    if (inputData.clientId !== "" && inputData.clientSecretKey !== "") {
      if (id !== undefined) {
        AxiosAPI({
          method: 'put',
          url: `${API_GooleAnalytics}/${id}?group_id=${getGroupID()}`,
          data: inputData,
        }).then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            toggle();
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }
        });
      } else {
        AxiosAPI({
          method: 'post',
          url: API_GooleAnalytics,
          data: inputData,
        }).then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            toggle();
            setTimeout(() => {
              window.location.reload();
            }, 300);
          }
        });

      }
    }
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? "Add" : "Update"} Google Analytics Integration</h6>
                <Separator className="mb-3" />
                <Form className="text-left">
                  <FormGroup className="mb-2">
                    <Label>Integration Name</Label>
                    <Input
                      //  type="text"
                      //   name="integrationName"
                      //   onChange={handleNameChange}
                      //   placeholder="Integration Name"
                      //   defaultValue={inputData.Name}
                      type="text"
                      name="integrationName"
                      value="Google Analytics"
                      readOnly
                      disabled
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Utm Source</Label>
                    <Input
                      type="utmSource"
                      name="utmSource"
                      onChange={handleClientKeyChange}
                      placeholder="Utm Source"
                      value={inputData.utmSource}
                    />
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <Label>Utm Medium</Label>
                    <Input
                      type="text"
                      name="utmMedium"
                      onChange={handleClientSecretChange}
                      placeholder="Utm Medium"
                      value={inputData.utmMedium}
                    />
                  </FormGroup>
                  <FormGroup className="mt-3">
                    <div className='integration-property '>
                      <CustomInput
                        type="checkbox"
                        id="select-all"
                        label="Select All"
                        checked={allSelected}
                        onChange={handleSelectAll}
                      />

                      {sortedProperties.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="checkbox"
                            id={index}
                            label={p.name}
                            value={p.id}
                            name="property"
                            checked={
                              inputData.Properties.length > 0 && inputData.Properties.filter(f => f === p.id).length > 0 ? true : false
                            }
                            onChange={() => handleCheckChange(p.id)}
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                </Form>
                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Intregation
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Intregation
                    </Button>
                  )}
                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
const mapStateToProps = ({ }) => {

};

export default injectIntl(connect(mapStateToProps, Changecloudbeds)(GoogleAnalyticsIntegration));

